

export default class Sound {
  private correctSound: HTMLAudioElement | undefined;
  private mistakeSound: HTMLAudioElement | undefined;

  public constructor() {
    this.correctSound = document.getElementById('sound1') as HTMLAudioElement;
    this.mistakeSound = document.getElementById('sound2') as HTMLAudioElement;

    this.correctSound.load();
    this.mistakeSound.load();
  }

  public mistake() {
    if (this.mistakeSound) {
      this.mistakeSound.play();
    }
  }

  public correct() {
    if (this.correctSound) {
      this.correctSound.play();
    }
  }
}
